import { Phone, Wrench, MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { PHONE_HREF, SMS_DRAFTS } from "@/lib/contact";
import { useSmsHref } from "@/components/site/ContactButtons";
import { findPieceBySlug } from "@/components/site/availableCatalog";
import { track } from "@/lib/track";

const draftForPath = (pathname) => {
  if (pathname.startsWith("/fountain-repair")) return SMS_DRAFTS.service;
  if (pathname.startsWith("/majestic")) return SMS_DRAFTS.majestic("I'd like to talk about building one");
  const m = pathname.match(/^\/piece\/([^/]+)/);
  if (m) {
    const piece = findPieceBySlug(m[1]);
    if (piece) return SMS_DRAFTS.product(piece.title, m[1]);
  }
  return SMS_DRAFTS.service;
};

const openStone = () => {
  track("chat_open", "Sticky mobile bar");
  if (typeof window !== "undefined") window.dispatchEvent(new Event("gfys-open-chat"));
};

export default function StickyMobileBar() {
  const { pathname } = useLocation();
  const smsHref = useSmsHref(draftForPath(pathname));
  return (
    <>
      <div aria-hidden className="h-[46px] md:hidden bg-[#1F1E1C]" />
      <div
        data-testid="sticky-mobile-bar"
        className="fixed bottom-0 inset-x-0 z-40 md:hidden grid grid-cols-[1.15fr_1fr_auto] border-t border-[#3A3835] shadow-[0_-4px_16px_rgba(0,0,0,0.25)]"
      >
        <a
          href={PHONE_HREF}
          onClick={() => track("call_click", "Sticky mobile bar")}
          data-testid="sticky-call-button"
          aria-label="Call Chris at (678) 769-9652"
          className="flex items-center justify-center gap-2 py-2.5 min-h-[46px] bg-[#7A6547] text-[#F9F6F0] text-[11px] tracking-[0.1em] uppercase"
        >
          <Phone size={14} strokeWidth={1.5} aria-hidden="true" />
          <span className="flex flex-col items-start leading-tight">
            <span>Call Chris</span>
            <span data-testid="sticky-call-sublabel" className="text-[9px] tracking-[0.18em] text-white/90 normal-case">Call directly</span>
          </span>
        </a>
        <a
          href={smsHref}
          onClick={() => track("text_click", "Sticky mobile bar")}
          data-testid="sticky-service-button"
          aria-label="Text Chris at (678) 769-9652"
          className="flex items-center justify-center gap-2 py-2.5 min-h-[46px] bg-[#1F1E1C] text-[#F9F6F0] text-[11px] tracking-[0.1em] uppercase"
        >
          <Wrench size={14} strokeWidth={1.5} aria-hidden="true" />
          <span className="flex flex-col items-start leading-tight">
            <span>Text Chris</span>
            <span data-testid="sticky-service-sublabel" className="text-[9px] tracking-[0.18em] text-white/90 normal-case">{pathname.startsWith("/fountain-repair") || pathname === "/" ? "Send a photo" : "Text directly"}</span>
          </span>
        </a>
        <button
          type="button"
          onClick={openStone}
          aria-label="Chat with Stone"
          data-testid="sticky-chat-button"
          className="flex items-center justify-center gap-1.5 px-3.5 min-w-[44px] bg-[#26241F] text-[#C8B387] text-[11px] tracking-[0.18em] uppercase border-l border-[#3A3835] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#C8B387]"
        >
          <MessageCircle size={16} strokeWidth={1.5} />
          <span data-testid="sticky-chat-label">Chat</span>
        </button>
      </div>
    </>
  );
}
